module.exports = __webpack_public_path__ + "static/media/amethystdp.5e57c081.jpg";